import React from 'react';
import { ReactMarkdown } from 'react-markdown/lib/react-markdown';
import remarkGfm from 'remark-gfm';
import styled from 'styled-components';

const StyledMarkdown = styled.div`
  & h2 {
    margin-top: 4rem;
  }
`;

const Markdown = ({ children }) => {
  return (
    <StyledMarkdown>
      <ReactMarkdown remarkPlugins={[remarkGfm]}>{children}</ReactMarkdown>
    </StyledMarkdown>
  );
};

export default Markdown;
